import { render } from "./ConsentItem.vue?vue&type=template&id=990bc746&scoped=true"
import script from "./ConsentItem.vue?vue&type=script&lang=js"
export * from "./ConsentItem.vue?vue&type=script&lang=js"

import "./ConsentItem.vue?vue&type=style&index=0&id=990bc746&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-990bc746"]])

export default __exports__